import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Button from 'components/Button'

import { fetchDrivers } from 'scenes/VehicleDetail/components/Drivers/actions'

import { statusChanged } from 'components/RequestStatus/actions'

import { CLIENT_DRIVER_URL } from 'constants'

const images = {
  noImage: require('img/users/notUser.gif')
}

export class Driver extends BaseComponent {

  constructor() {
    super()

    this._bind('_deleteDriver')
  }

   _deleteDriver() {
     const params = this.props.params
     const userId = this.props.driver.user.uuid
     this.props.updateRequestStatus('progress', 'Eliminando Usuario')

     request(CLIENT_DRIVER_URL(params.id, params.vehicleId, userId), {
       method: 'DELETE'
     })
    .then((res) => {
      this.props.fetchDrivers(this.props.params.id, this.props.params.vehicleId)
      this.props.updateRequestStatus('ok', 'Conductor eliminado')
    })
    .catch((err) => {
      this.props.updateRequestStatus('error', 'No pudímos eliminar al usuario')
    })
  }


  render() {
    const driver = this.props.driver.user
    const driverName = !!driver.first_name ? `${driver.first_name} ${driver.last_name}` : 'Sin Nombre'
    const profilePhoto = driver.picture || images.noImage
    const bgImage = {
      'backgroundImage': `url(${profilePhoto})`
    }

    return (
      <div id="Driver">
        <div className="Driver__data d-flex justify-content-between">
          <div className="Driver__image">
            <div className="image" style={bgImage}></div>
          </div>
          <div className="Driver__person">
            <p className="name">{driverName}</p>
            <p>{driver.email}</p>
          </div>
        </div>
        <div className="Driver__delete">
          <Button onClick={this._deleteDriver}>Remover conductor</Button>
        </div>
      </div>
    )
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    fetchDrivers: (userId, vehicleId) => dispatch(fetchDrivers(userId, vehicleId))
  }
}

export default connect(null, mapDispatchToProps)(Driver)

Driver.defaultProps = {
  driver: {
    user: {
      uuid: '',
      first_name: '',
      last_name: '',
      email: ''
    }
  }
}

Driver.propTypes = {
  driver: PropTypes.shape({
    user: PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      first_name: PropTypes.string.isRequired,
      last_name: PropTypes.string.isRequired,
      picture: PropTypes.string,
      email: PropTypes.string.isRequired,
    })
  })
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Drivers/DriverList/Driver.js